import { useEffect, useState } from 'react';
import { Api } from '../../services/api';
import { conversorData } from '../../utils/dataFunc';

export const CanhotoPage = () => {
  const [canhotos, setCanhotos] = useState();

  const findCanhotos = async () => {
    try {
      const resp = await Api.get('/canhotos/0');
      setCanhotos(resp.data);
    } catch (e) {
      setCanhotos(null);
    }
  };

  useEffect(() => {
    findCanhotos();
  }, []);
  return (
    <div className="mt-4 container">
      <div className="mt-4"></div>
      <div className="row">
        <div className="input-group mb-4">
          <input type="text" className="form-control" placeholder="Pesquisar canhoto" aria-label="Pesquisar canhoto" />
          <button
            className="btn btn-outline-secondary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Tudo
          </button>
          <ul className="dropdown-menu dropdown-menu-end">
            <li>
              <button className="dropdown-item" href="#">
                Por carga
              </button>
            </li>
            <li>
              <button className="dropdown-item" href="#">
                Por nota fiscal
              </button>
            </li>
            <li>
              <button className="dropdown-item" href="#">
                Por Token
              </button>
            </li>
          </ul>
          <button className="btn btn-outline-secondary" type="button">
            Pesquisar
          </button>
        </div>
        <div className="mt-1"></div>

        <div className="row" style={{ justifyContent: 'center', textAlign: 'center' }}>
          {canhotos &&
            canhotos.map(
              (canhoto) =>
                canhoto.arquivo && (
                  <a
                    key={canhoto.id}
                    className="card mb-4"
                    style={{ textDecoration: 'none', width: '18rem', marginRight: '1%', marginLeft: '1%' }}
                    href={`https://canhoto.srembalagens.com.br/${canhoto.arquivo}?a`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={`https://canhoto.srembalagens.com.br/${canhoto.arquivo}?a`}
                      className="card-img-top pt-2"
                      alt="..."
                    />
                    <div className="card-body">
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">NF {canhoto.nf}</li>
                        <li className="list-group-item">{canhoto.status.descricao}</li>
                        <li className="list-group-item">{conversorData(canhoto.updatedAt)}</li>
                      </ul>
                    </div>
                  </a>
                ),
            )}
        </div>
      </div>
    </div>
  );
};
